import { Account } from 'src/app/services/models/account/account.model';

export interface ILoginState {
  currentLogin: Account;
}

export const initialLoginState: ILoginState = {
  currentLogin: null,
};
